import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  closeCtaDrawerAriaLabel: {
    id: 'cta_drawer.close.aria_label',
    description: 'Close drawer button',
    defaultMessage: 'Close booking options drawer'
  },
  ctaDrawerHeading: {
    id: 'cta_drawer.heading',
    description: 'Heading for CTA drawer',
    defaultMessage: 'Book with {providerName}'
  },
  bookOnlineTitle: {
    id: 'booking_options.bookOnline.title',
    description: 'Title for book online option',
    defaultMessage: 'Book Online'
  },
  bookOnlineSubtitle: {
    id: 'booking_options.bookOnline.subtitle',
    description: 'Subtitle for book online option',
    defaultMessage: ' '
  },
  phoneTitle: {
    id: 'booking_options.phone.title',
    description: 'Title for phone option',
    defaultMessage: 'Call to Book '
  },
  phoneSubtitle: {
    id: 'booking_options.phone.subtitle',
    description: 'Subtitle for phone option',
    defaultMessage: ' '
  },
  requestFormTitle: {
    id: 'booking_options.request_form.title',
    description: 'Title for appointment request form option',
    defaultMessage: 'Submit Appointment Request Form'
  },
  requestFormSubtitle: {
    id: 'booking_options.request_form.subtitle',
    description: 'Subtitle for appointment request form option',
    defaultMessage: ' '
  },
  virtualCareTitle: {
    id: 'booking_options.virtual_care.title',
    description: 'Title for virtual care option',
    defaultMessage: 'Book a Virtual Care Visit'
  },
  virtualCareSubtitle: {
    id: 'booking_options.virtual_care.subtitle',
    description: 'Subtitle for virtual care option',
    defaultMessage: ' '
  },
  externalLinkAriaLabel: {
    id: 'booking_options.external_link.aria_label',
    description: 'Indication that an external website opens in a new tab',
    defaultMessage: 'Opens in a new tab'
  }
});
